export enum AnnotationSettingsReturnCodes {
    Success = 0,
    NoSelection = 1,
    UnlockedView = 2,
    IncorrectFamilyTag = 3,
    NoMessage = 4
}